"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentCanvasPaginationReact = exports.DocumentCanvasPagination = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../store/store");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactPdf = require("react-pdf");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var pdfjsLib = require('pdfjs-dist');

// The workerSrc property shall be specified.
pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(_reactPdf.pdfjs.version, "/pdf.worker.min.js");
var DocumentCanvasPaginationReact = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DocumentCanvasPaginationReact, _Component);
  var _super = _createSuper(DocumentCanvasPaginationReact);
  function DocumentCanvasPaginationReact(props) {
    var _this;
    (0, _classCallCheck2.default)(this, DocumentCanvasPaginationReact);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDocumentLoadSuccess", function (_ref) {
      var numPages = _ref.numPages;
      _this.setState({
        numPages: numPages,
        loading: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handlePrevious", function () {
      _this.setState(function (state) {
        if (state.pageNumber > 1) {
          return {
            pageNumber: state.pageNumber - 1
          };
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleNext", function () {
      _this.setState(function (state) {
        if (state.pageNumber < state.numPages) {
          if (state.pageNumber === 4) {
            _this.props.updateFormField({
              isDocumentViewed: true
            });
          }
          return {
            pageNumber: state.pageNumber + 1
          };
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "spinner", function () {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "lcSpinner"
      });
    });
    _this.state = {
      numPages: null,
      loading: true,
      pageNumber: 1
    };
    return _this;
  }
  (0, _createClass2.default)(DocumentCanvasPaginationReact, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        pageNumber = _this$state.pageNumber,
        numPages = _this$state.numPages,
        loading = _this$state.loading;
      var _this$props = this.props,
        siteInfo = _this$props.siteInfo,
        document = _this$props.document;
      var iframeURL = document.iframeURL,
        BROWSER_SUPPORT_MESSAGE = document.BROWSER_SUPPORT_MESSAGE;
      var basePath = siteInfo.basePath;
      var queryStr = "".concat(iframeURL.split('?')[1] ? '&' : '?', "hasPdfPlugin=true");
      var docIframeURL = "".concat(basePath).concat(iframeURL).concat(queryStr);
      var linkURL = "".concat(basePath).concat(iframeURL) === '' ? null : /*#__PURE__*/_react.default.createElement("a", {
        href: docIframeURL,
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Click here to download and print the entire PDF.");
      var fallBackTxt = /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", null, BROWSER_SUPPORT_MESSAGE), " ", linkURL);
      var pagesClass = loading ? 'pages hidden' : 'pages';
      var pageNav = loading ? null : /*#__PURE__*/_react.default.createElement("div", {
        className: "page-nav"
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.handlePrevious
      }, "<"), /*#__PURE__*/_react.default.createElement("span", {
        className: "document-nav"
      }, "Displaying Page ", pageNumber, " of ", numPages), /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.handleNext
      }, ">"));
      var pdfCanvas = /*#__PURE__*/_react.default.createElement("div", {
        id: "document-container"
      }, loading && this.spinner(), /*#__PURE__*/_react.default.createElement("div", {
        className: pagesClass
      }, /*#__PURE__*/_react.default.createElement(_reactPdf.Document, {
        file: docIframeURL,
        onLoadSuccess: this.onDocumentLoadSuccess,
        loading: this.spinner()
      }, /*#__PURE__*/_react.default.createElement(_reactPdf.Page, {
        pageNumber: pageNumber
      }))));
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fallBackTxt, /*#__PURE__*/_react.default.createElement("div", null, pdfCanvas), pageNav);
    }
  }]);
  return DocumentCanvasPaginationReact;
}(_react.Component);
exports.DocumentCanvasPaginationReact = DocumentCanvasPaginationReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    document: state.document,
    siteInfo: state.siteInfo
  };
};
DocumentCanvasPaginationReact.propTypes = {
  document: _propTypes.default.object.isRequired,
  siteInfo: _propTypes.default.object.isRequired,
  updateFormField: _propTypes.default.func.isRequired
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var DocumentCanvasPagination = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DocumentCanvasPaginationReact);
exports.DocumentCanvasPagination = DocumentCanvasPagination;
